<vault-organization-user-notifications class="tw-shrink-0"></vault-organization-user-notifications>
<vault-shared-folders>
  <app-header>
    <vault-shared-folders-breadcrumbs slot="breadcrumbs" />
  </app-header>
</vault-shared-folders>
